import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons, FooterError } from '@/design_system/Footer';
import { ShipmentWithRelations, useCompleteVerification } from '@/models/shipment';

const VerificationActions = ({
  shipment,
  onVerificationDone,
}: {
  shipment: ShipmentWithRelations;
  onVerificationDone: () => void;
}) => {
  const {
    mutateAsync: completeVerification,
    isPending: isCompleteVerificationPending,
    isSuccess: isCompleteVerificationSuccess,
  } = useCompleteVerification();
  const [showError, setShowError] = useState(false);

  const hasError = !shipment.articles
    .filter((article) => !article.article.archivedAt)
    .every((article) => article.verified);

  return (
    <Footer>
      {showError && hasError && (
        <FooterError>
          <Trans id="shipment.verification.error">
            Please verify all the items before marking the package verification as complete.
          </Trans>
        </FooterError>
      )}
      <FooterButtons>
        <Button
          variant="primary"
          onPress={async () => {
            setShowError(true);

            if (hasError) {
              return;
            }

            await completeVerification(shipment.id);
            onVerificationDone();
          }}
          isLoading={isCompleteVerificationPending || isCompleteVerificationSuccess}
        >
          <Trans id="shipment.verification.conclude">Mark verification as completed</Trans>
        </Button>
      </FooterButtons>
    </Footer>
  );
};

export default VerificationActions;
